import {ChildEntity, Column} from "typeorm";
import {Incident} from "@/modules/match/entity/Incident";
import {SubstitutionTypeEnum} from "@/modules/match/enums";
import SubstitutionIncidentComponent from '@/modules/match/components/SubstitutionIncident.vue';
import SubstitutionIncidentLiveComponent from '@/modules/match/components/live-incident/SubstitutionIncident.vue';
import {Component, ShallowRef} from "vue";

@ChildEntity()
export class SubstitutionIncident extends Incident {
  @Column({type: 'varchar', enum: SubstitutionTypeEnum})
  substitutionType: SubstitutionTypeEnum;

  get component(): ShallowRef<Component> {
    return shallowRef(SubstitutionIncidentComponent);
  }

  get liveComponent(): ShallowRef<Component> {
    return shallowRef(SubstitutionIncidentLiveComponent);
  }
}
